/**
 * a list of phonemes for misc languages
 */
export const segmentsForMisc: Record<string, string> = {
  // https://en.wikipedia.org/wiki/Esperanto_phonology
  // contested: d͡z x w
  Esperanto: "m n p t k b d ɡ ts t̠ʃ d̠ʒ f s ʃ h v z ʒ l j r a e i o u",
}
